import { NgModule } from '@angular/core';
import { InoElementsModule as DefaultInoElementsModule } from '@inovex.de/elements-angular';

@NgModule({
  imports: [DefaultInoElementsModule.forRoot()],
  exports: [DefaultInoElementsModule],
})
export class InoElementsModule {}
